// extracted by mini-css-extract-plugin
export default {"smallFooter":"SmallFooter_smallFooter__nBe8h"};